import {
  Box,
  Button,
  Card,
  Chip,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import MyDocument from "../../../../components/PdfGenerator/MyDocument";
import { pdf } from "@react-pdf/renderer";
import CudelLogo from "../../../../assets/images/cudel_logo.png";
import ImageAsBase64 from "../../../../utils/imageToBase64";
import AuthorizedSignature from "../../../../assets/images/dummy_signature.png";
import stateList from "../../../../utils/stateList";
import { numberToWords } from "../../../../utils/numberToWords";
import pdfLogo from "../../../../assets/images/pdf-icon-4.png";
import RegistrationFeeSection from "./RegistrationFee";

const PaymentDetails = ({ paymentList }) => { 
  const [registrationFee, setRegistrationFee] = useState(null);

  
  
  useEffect(() => {    
    if (paymentList && paymentList.length > 0) {
      const registrationFee = paymentList.find(
        (payment) => payment.paymentType == "REGISTRATION_FEE"
      );
      if (registrationFee) {
        setRegistrationFee(registrationFee);
      }
    }
  }, []);

  
  return (
    <Grid container>
      {/* =======================Registration fee Info section================== */}
      <RegistrationFeeSection registrationFee={registrationFee}/>
    </Grid>
  );
};

export default PaymentDetails;

//   const invoiceData = {
//     // Company Information
//     company: {
//       name: "Cudel Delight Solutions Pvt. Ltd.",
//       address: "B-154, Sector-63, Noida, Gautambuddha Nagar,",
//       state: "Uttar Pradesh",
//       pincode: "201301",
//       gstin: "09AAHCC0707E1ZP",
//       stateCode: "09"
//     },

//     // Invoice Details
//     invoice: {
//       number: "CD/000015/UP/24",
//       date: "26-Dec-24",
//       reference: "472619773006",
//       mode: "Mode/Terms of Payment"
//     },

//     // Buyer Information
//     buyer: {
//       name: "M/S Gyanwati",
//       address: "Morna, Sector 35, Noida",
//       state: "Uttar Pradesh",
//       pincode: "201301",
//       panIt: "GHFPG9473D",
//       gstin: "09XXXXX1234X1ZX",
//       placeOfSupply: "Uttar Pradesh",
//       stateCode: "09",
//       // stateCode: "10",
//       buyerOrderNo: "PO123456",
//       termsOfDelivery: "Immediate"
//     },

//     // Items/Services
//     items: [
//       {
//         description: "Registration Fees",
//         hsnSac: "996331",
//         rate: 555.00,
//         quantity: 1,
//         amount: 622.155,
//         cgstRate: 9,
//         sgstRate: 9,
//         igstRate: 0,
//         // cgstRate:0,
//         // sgstRate:0,
//         // igstRate:18,
//         discount:5
//       },
//       {
//         description: "Annual Subscription",
//         hsnSac: "996332",
//         rate: 1445.00,
//         quantity: 1,
//         amount: 1365.525,
//         cgstRate: 2.5,
//         sgstRate: 2.5,
//         igstRate: 0,
//         // cgstRate:0,
//         // sgstRate:0,
//         // igstRate:18,
//         discount:10
//       },
//       {
//         description: "Kit Fee",
//         hsnSac: "996333",
//         rate: 1000.00,
//         quantity: 1,
//         amount: 1000.00,
//         cgstRate: 9,
//         sgstRate: 9,
//         igstRate: 0,
//         // cgstRate:0,
//         // sgstRate:0,
//         // igstRate:18,
//         discount:0
//       }
//     ],

//     // Totals
//     totals: {
//       subTotal: 2000.00,
//       cgstTotal: 630.00,
//       sgstTotal: 630.00,
//       igstTotal: 0,
//       grandTotal: 8260.00,
//       amountInWords: "Indian Rupees Eight Thousand Two Hundred Sixty Only"
//     },

//     // Tax Details
//     taxBreakup: [
//       {
//         type: 'Intra State',
//         rate: 18,
//         taxableValue: 2000.00,
//         cgstAmount: 180.00,
//         sgstAmount: 180.00,
//         igstAmount: 0
//       }
//     ],

//     // Additional Details
//     additional: {
//       remarks: "Reference: 472619773006, DATE-25.12.2024",
//       bankDetails: {
//         bankName: "HDFC Bank",
//         accountNo: "XXXXXXXXXXXX1234",
//         ifscCode: "HDFC0001234",
//         branch: "Noida Sector 63"
//       },
//       termsAndConditions: [
//         "1. Payment should be made within 30 days",
//         "2. Goods once sold cannot be returned",
//         "3. Interest at 18% p.a. will be charged on delayed payments"
//       ]
//     }
//   }
